import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("DocumentContentReplacePropertyValueOutput")
export class DocumentContentReplacePropertyValueOutput {
    @JsonProperty()
    public documentContentIds: string[] = JsonPropertyEmpty;
}
